import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './motoristaForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, getLista, getListaCnhCategoria } from './motoristaActions';
import { getLista as getListaTransportadora } from '../transportadora/transportadoraActions';

const columns = [{
    field: 'nome',
    type: 'text'
}, {
    field: 'cpf',
    type: 'text'
}, {
    field: 'nome_transportadora',
    type: 'text'
}, {
    field: 'cnh_numero',
    type: 'int'
}, {
    field: 'cnh_categoria',
    type: 'text'
}];

class Motorista extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'nome',
			direction: 'asc' // 'asc' | 'desc'
		}
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaCnhCategoria();
		this.props.getListaTransportadora();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.nome}
					${item.cpf}
					${item.nome_transportadora}
					${item.cnh_numero}
					${item.cnh_categoria}
				`.toUpperCase().includes(pesquisar)
				);
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;

		const listaAux = this.filtrar();

		let lista = [];
		listaAux.forEach(item => {
			lista.push(item)
		});		

		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<InputPesquisa
							cols='12 6 3 1'
							label='Pesquisar'
							minWidth={344}
							onChange={value => this.setState({ ...this.state, pesquisar: value })} />

						<div style={{ marginTop: 8, width: 270 }}>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ tipo_pessoa: 'juridica' });
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<ExcelFile
								filename={'Motoristas'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								{this.montarExcel(lista)}
							</ExcelFile>
						</div>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border alturaFixa striped
						maxHeight={window.innerWidth < 631 ? window.innerHeight - 260 : window.innerHeight - 180}>
						<THead>
							<Tr>
								<ThSort
									field='nome'
									label='Nome'
									width={300}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='cpf'
									label='CPF'
									width={100}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='nome_transportadora'
									label='Transportadora'
									width={200}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='cnh_numero'
									label='CNH'
									width={100}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='cnh_categoria'
									label='Categoria'
									width={10}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<Th sticky alignCenter width={50}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={i}
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.cpf}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_transportadora}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.cnh_numero}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.cnh_categoria}</Td>
									<Td alignCenter minWidth={130} maxWidth={130}>
										<ButtonTable
											type={'warning'}
											width={32}
											small
											icon={'fas fa-pencil-alt'}
											visible={true}
											title='Editar'
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											width={32}
											small
											icon={'fas fa-trash-alt'}
											visible={true}
											title='Excluir'
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(lista) {

		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={lista.map(item => ({
				...item
			}))} name='Motoristas'>
				{[
					{ componente: <ExcelColumn key={1} label='Código da Integração' value='codigo_integracao'/>},
					{ componente: <ExcelColumn key={2} label='Nome' value='nome'/>},
					{ componente: <ExcelColumn key={3} label='CPF' value='cpf'/>},
					{ componente: <ExcelColumn key={4} label='RG' value='RG'/>},
					{ componente: <ExcelColumn key={5} label='CNH' value='cnh_numero'/>},
					{ componente: <ExcelColumn key={6} label='Categoria' value='cnh_categoria'/>},
					{ componente: <ExcelColumn key={7} label='Transportadora' value='nome_transportadora'/>},
					{ componente: <ExcelColumn key={8} label='Telegram' value='telegram'/>},
					{ componente: <ExcelColumn key={9} label='WhatsApp' value='whatsapp'/>},
					{ componente: <ExcelColumn key={10} label='E-mail' value='email'/>},
					{ componente: <ExcelColumn key={11} label='Usuário da Inclusão' value='nome_usuario_inclusao'/>},
					{ componente: <ExcelColumn key={12} label='Usuário da Alteração' value='nome_usuario_alteracao'/>}
				].filter(item => {
					return true;
				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.motorista.modoTela,
	aguardando: state.motorista.aguardando,
	lista: state.motorista.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaCnhCategoria, getListaTransportadora
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Motorista);